import axios from 'axios';
import { useMutation } from 'react-query';

export type IntegrateResponse = {
  code: string;
  message: string;
};

const integrateMerchant = async (
  merchantId: string,
): Promise<IntegrateResponse> => {
  const { data } = await axios.post(`/api/merchants/${merchantId}/integrate`);
  return data;
};

export const useIntegrate = ({ onSuccess, onError }) => {
  return useMutation(integrateMerchant, {
    onSuccess,
    onError,
  });
};
